import { createApp } from "vue";
import store from "../../common/js/store";
import registerServiceWorker from "./serviceWorkerRegistration";

// Global components import

import SearchModal from "../../common/js/components/SearchModal.vue";
import BottomBar from "../../common/js/components/BottomBar.vue";
import VerticalProductScroll from "../../common/js/components/VerticalProductScroll.vue";
import CustomizationInit from "../../common/js/components/CustomizationInit.vue";
import GenericModal from "../../common/js/components/GenericModal.vue";
import ProductCardModal from "../../common/js/components/ProductCardModal.vue";
import Ripple from "../../common/js/helpers/ripple";
const app = createApp({});
app.use(store);

// Global components registration
// @todo: similarly all other components registration currently inside Home.vue will move here and Home.vue will be discarded

app.directive("ripple", Ripple);
app.component("search-modal", SearchModal);
app.component("bottom-bar", BottomBar);
app.component("vertical-product-scroll", VerticalProductScroll);
app.component("customization-init", CustomizationInit);
app.component("generic-modal", GenericModal);
app.component("product-card-modal", ProductCardModal);

app.mount("#themeDefaultSearch");
// @todo : uncomment this...

registerServiceWorker();

if (typeof window != "undefined") {
  window.onbeforeunload = () => {
    window.scrollTo(0, 0);
  };
}
